// extracted by mini-css-extract-plugin
export default {"paper":"DetailedBalanceLeveling_paper__2xXZK","pagination":"DetailedBalanceLeveling_pagination__y3xS2"};